export default __webpack_public_path__ + "static/media/closet4.2afc2559.jpg";